import { api, getApiUrl } from 'utils/api';

import { FavoriteSchool } from './inbox';

const BASE_URL = getApiUrl('/interveners/me/intervention-plans');

export const interventionPlansApi = {
  getFavorites: (planId: number): Promise<FavoriteSchool[]> =>
    api(`${BASE_URL}/${planId}/favorites`, { method: 'GET' }),

  setFavorites: (planId: number, schoolIds: number[]): Promise<FavoriteSchool[]> =>
    api(`${BASE_URL}/${planId}/favorites`, { method: 'PUT', payload: { schoolIds } }),
};
